import BasicModel from '../basic/BasicModel'
export default {
  deleteProduct(vm,params,listener) {
    let action = 'carShow/business/deleteProduct.action'
    BasicModel.post(vm, action, params, listener)
  },
  upProduct(vm,params,listener){
    let action = 'carShow/business/businessProductTop.action'
    BasicModel.post(vm, action, params, listener)
  },
  passWithdrawCash: function(vm, params, listener){
    let action = 'carShow/user/passWithdrawCash.action'
    BasicModel.post(vm, action, params, listener)
  },
  notPassWithdrawCash: function(vm, params, listener){
    let action = 'carShow/user/notPassWithdrawCash.action'
    BasicModel.post(vm, action, params, listener)
  },
  updateBusinessSortValue: function(vm, params, listener){
    let action = 'carShow/business/updateSort.action'
    BasicModel.post(vm, action, params, listener)
  },
  upActivity: function(vm, params, listener){
    let action = 'carShow/business/businessActivityTop.action'
    BasicModel.post(vm, action, params, listener)
  },
  deleteActivity: function(vm, params, listener){
    let action = 'carShow/business/deleteActivity.action'
    BasicModel.post(vm, action, params, listener)
  },
  recoveryActivity: function(vm, params, listener){
    let action = 'carShow/business/recoveryActivity.action'
    BasicModel.post(vm, action, params, listener)
  },
  refundOrder: function(vm,params,listener){
    let action = 'carShow/order/refund.action'
    BasicModel.post(vm, action, params, listener)
  },
  exchangeOrder: function(vm,params,listener){
    let action = 'carShow/order/exchange.action'
    BasicModel.post(vm, action, params, listener)
  },
  selectCarShowStatisticsInfo: function(vm,params,listener){
    let action = 'carShow/carShowInfo/selectCarShowStatisticsInfo.action'
    BasicModel.get(vm, action, params, listener)
  }  ,
  selectWithdrawMoneyReport: function(vm,params,listener){
    let action = 'carShow/user/selectWithdrawMoneyReport.action'
    BasicModel.get(vm, action, params, listener)
  },
  deleteBusiness: function(vm,params,listener){
    let action = 'carShow/business/deleteBusiness.action'
    BasicModel.post(vm, action, params, listener)
  },
  recoveryBusiness: function(vm,params,listener){
    let action = 'carShow/business/recoveryBusiness.action'
    BasicModel.post(vm, action, params, listener)
  }
}
